const urls = {
  'localhost:7074': '测试',
  'data.quexiaoxian.com': '雀小仙',
  'www.weimale.com': '四方城',
  'quexiaoyu.cn': '雀小渔',
  'www.syuplay.com': '双友自助棋牌',
  'www.fangheqipai.com': '方和自助棋牌'
}

// const protocol = window.location.protocol
// const host = window.location.host

// const protocol = 'https:'
// const host = 'www.weimale.com'

const protocol = 'https:'
const host = 'data.quexiaoxian.com'

// const protocol = 'http:'
// const host = 'localhost:7074'

const base = protocol + '//' + host + '/sh-manage'
const baseQR = 'https://' + host.replace(/^(www|data)/, 'xcx') + '/'
const baseName = urls[host]
document.title = baseName + '管理后台'

export { base, baseQR, baseName }
